import { render, staticRenderFns } from "./SharingTab.vue?vue&type=template&id=fd952d0e&scoped=true"
import script from "./SharingTab.vue?vue&type=script&lang=js"
export * from "./SharingTab.vue?vue&type=script&lang=js"
import style0 from "./SharingTab.vue?vue&type=style&index=0&id=fd952d0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd952d0e",
  null
  
)

export default component.exports